<template>
  <v-icon @click="emitUpdateDialogAction" class="actions_small"
    >mdi-plus</v-icon
  >
  <v-dialog
    v-model="dialogTraineeAction"
    transition="dialog-top-transition"
    persistent
    max-width="800"
    min-width="400"
  >
    <v-card class="rounded-lg pa-4" color="dialog">
      <v-card-title class="headline">{{ ActionAddTitle }}</v-card-title>
      <v-card-text>
        <div class="field_form">
          <label for="nouvelleDateDeFin" class="label_datePicker"
            >Nouvelle Date de fin :
          </label>
          <input
            type="date"
            prepend-icon="mdi-calendar"
            id="NouvelleDateDeFin"
            v-model="newSelectedEndDate"
          />
        </div>
        <br />
        <div class="field_form">
          <label for="nouvelledateExamen" class="label_datePicker"
            >Nouvelle Date d'Examen (optionel):
          </label>
          <input
            type="date"
            prepend-icon="mdi-calendar"
            id="nouvelledateExamen"
            v-model="newExamDate"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialogTraineeAction = false"
          >Annuler</v-btn
        >
        <v-btn
          color="primary"
          text
          @click="
            prolongationTrainingSession(
              field,
              item,
              action,
              newSelectedEndDate,
              newExamDate
            ),
              (dialogTraineeAction = false)
          "
          >Confirmer</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000">
    <p v-html="snackbarMessage"></p>
  </v-snackbar>
</template>

<script>
import authExpirationMixin from "@/mixins/isLogged.js";

import axios from "axios";
import {
  base_url,
  trainingblocsubscriptions_urls,
  header,
} from "@/API/config.js";

export default {
  mixins: [authExpirationMixin],

  props: {
    ActionAddTitle: String,
    item: Object,
  },
  emits: [
    "refresh-training-subscriptions",
    "selected-end-date-changed",
    "exam-date-changed",
    "handleSelectedEndDateChanged",
    "handleExamDateChanged",
  ],

  data() {
    return {
      dialogTraineeAction: false,
      newSelectedEndDate: null,
      newSelectedExamDate: null,
      selectedExamDate: null,
      newExamDate: null,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
    };
  },

  watch: {
    newSelectedEndDate(newEndDate) {
      this.$emit("selected-end-date-changed", newEndDate);
    },

    newExamDate(newExamDate) {
      this.$emit("exam-date-changed", newExamDate);
    },
  },

  methods: {
    async prolongationTrainingSession(field, item) {
      try {
        const selectedTrainingBlocSubscription =
          item.ID_FS_TrainingBlocSubscription;
        const currentTrainingblocSubscription =
          await this.fetchCurrentSubscription(selectedTrainingBlocSubscription);

        const currentSubscriptionEnd = new Date(
          currentTrainingblocSubscription.DAT_SubscriptionEnd
        );
        const newSubscriptionEnd = new Date(this.newSelectedEndDate);

        if (newSubscriptionEnd < currentSubscriptionEnd) {
          this.snackbarMessage = `La nouvelle Date de fin doit être après l'ancienne date de fin initiale.`;
          this.snackbarColor = "error";
          this.snackbar = true;
          return;
        }

        await this.pauseCurrentSubscription(selectedTrainingBlocSubscription);
        const postUrl = `${base_url}${trainingblocsubscriptions_urls.post}`;

        const newExamDate = this.newExamDate
          ? new Date(this.newExamDate)
          : null;

        const newSubscription = {
          DAT_SubscriptionStart:
            currentTrainingblocSubscription.DAT_SubscriptionEnd,
          DAT_SubscriptionEnd: this.newSelectedEndDate,
          DAT_SubscriptionDate: new Date().toISOString().split("T")[0],
          DAT_FinalTestScheduled: newExamDate
            ? newExamDate.toISOString().split("T")[0]
            : null,
          TXT_SubscriptionStatus: "extension",
          BIT_Extention: true,
          BIT_Resumption: false,
          BIT_Cancelled: false,
          ID_D_Trainee: parseInt(currentTrainingblocSubscription.ID_D_Trainee),
          ID_D_TrainingBloc: parseInt(
            currentTrainingblocSubscription.ID_D_TrainingBloc
          ),
          ID_Subscription: parseInt(
            currentTrainingblocSubscription.ID_Subscription
          ),
          TXT_Cohort: currentTrainingblocSubscription.TXT_Cohort,
        };

        try {
          const response = await axios.post(postUrl, newSubscription, header);
          this.snackbarMessage =
            "La session de formation a été prolongée avec succès";
          this.snackbarColor = "success";
          this.snackbar = true;
          console.log("create", response);
        } catch (error) {
          this.handleProlongationError(error);
        }

        this.snackbarMessage =
          "La session de formation a été prolongée avec succès";
        this.snackbarColor = "success";
        this.snackbar = true;
        this.$emit("refresh-training-subscriptions");
      } catch (error) {
        this.handleProlongationError(error);
      }
    },

    handleProlongationError(error) {
      this.snackbarMessage = `La session de formation n'a pas été mise à jour`;
      this.snackbarColor = "error";
      this.snackbar = true;
      console.error(
        "Erreur lors de la prolongation de la session de formation:",
        error
      );
    },

    // --- Méthodse liées --- //

    emitUpdateDialogAction() {
      this.dialogTraineeAction = true;
    },

    async fetchCurrentSubscription(selectedTrainingBlocSubscription) {
      const url = `${base_url}${trainingblocsubscriptions_urls.get_details(
        selectedTrainingBlocSubscription
      )}`;
      const CurrentSubscription = await axios.get(url, header);
      return CurrentSubscription.data;
    },

    async pauseCurrentSubscription(selectedTrainingBlocSubscription) {
      const url = `${base_url}${trainingblocsubscriptions_urls.get_details(
        selectedTrainingBlocSubscription
      )}`;

      const updatedSubscription = {
        ...this.CurrentSubscription,
        BIT_Extention: true,
        BIT_Resumption: false,
        BIT_Cancelled: true,
        TXT_SubscriptionStatus: "prolongé",
      };

      try {
        const reponse = await axios.put(url, updatedSubscription, header);
        console.log("put", reponse);
      } catch (error) {
        console.error(
          "Erreur lors de la mise en pause de la souscription :",
          error
        );
      }
    },

    handleSelectedEndDateChanged(newEndDate) {
      this.newSelectedEndDate = newEndDate;
      this.$emit("update:endDate", newEndDate);
    },
    handleExamDateChanged(newExamDate) {
      this.selectedExamDate = this.newExamDate; // This should be this.newExamDate
      this.$emit("update:examDate", newExamDate);
    },
  },
};
</script>
